export const recordData$ = state => state.record.recordData;
export const recordLoading$ = state => state.record.isLoading;
export const recordError$ = state => state.record.error;
export const userSectionStats$ = state => state.record.userSectionStats;
export const monthlyAccuracyData$ = state => state.record.monthlyAccuracyData;
export const dailyAccuracyTrend$ = state => state.record.dailyAccuracyTrend;
export const monthlyAccuracyLoading$ = state => state.record.isLoadingMonthlyAccuracy;
export const dailyTrendLoading$ = state => state.record.isLoadingDailyTrend;
